import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stRedPacketPackets } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingRedpacketPackets;

export const redpacketPacketsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const status = (params.filter?.status as string | undefined) || undefined;
    const roomName = String(params.filter?.roomName || '').trim() || undefined;
    const res = await stRedPacketPackets({
      status,
      roomName,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
